module.exports = __webpack_public_path__ + "static/media/leftln.d6e434d6.png";